import SmallLoader from "./SmallLoader";

export default SmallLoader;
